const COLORS = ["#f97316", "#22c55e", "#3b82f6", "#ec4899", "#a855f7", "#14b8a6", "#eab308", "#ef4444"];

export function colorForClientId(clientId) {
  let hash = 0;
  for (let i = 0; i < clientId.length; i++) {
    hash = (hash * 31 + clientId.charCodeAt(i)) >>> 0;
  }
  return COLORS[hash % COLORS.length];
}
